var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmationEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 193,
    viewBox: "0 0 165 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6562_23080)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.2611 193C53.3288 193 25.0115 190.366 25.0115 187.114C25.0115 183.863 53.3288 181.227 88.2611 181.227C123.193 181.227 151.511 183.861 151.511 187.114C151.511 190.368 123.193 193 88.2611 193Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.894 62.4751H20.7494C16.5653 62.4751 13.1733 65.867 13.1733 70.0512V158.8C13.1733 162.984 16.5653 166.376 20.7494 166.376H158.894C163.078 166.376 166.47 162.984 166.47 158.8V70.0512C166.47 65.867 163.078 62.4751 158.894 62.4751Z",
    fill: "#E8E8EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.704 74.1635H20.9399C16.6497 74.1635 13.1733 70.685 13.1733 66.3969L87.4537 0L166.47 66.3969C166.47 70.6871 162.992 74.1635 158.704 74.1635Z",
    fill: "#E8E8EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0275 101.667C113.279 101.667 132.129 82.8173 132.129 59.5653C132.129 36.3133 113.279 17.4639 90.0275 17.4639C66.7755 17.4639 47.926 36.3133 47.926 59.5653C47.926 82.8173 66.7755 101.667 90.0275 101.667Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6562_23080",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 8,
    width: 104,
    height: 103
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.454 8.13916H38.603V110.99H141.454V8.13916Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6562_23080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.0275 8.13916C61.6106 8.13916 38.601 31.1467 38.601 59.5657C38.601 87.9847 61.6085 110.992 90.0275 110.992C118.447 110.992 141.454 87.9847 141.454 59.5657C141.491 31.1835 118.481 8.13916 90.1011 8.13916H90.0297H90.0275ZM119.204 44.2014L88.2266 80.6965C87.3239 81.7788 86.0273 82.3914 84.6203 82.3546C83.2133 82.3546 81.9146 81.742 81.0141 80.6965L60.8552 56.9314C59.0889 54.9832 59.2317 52.0264 61.1799 50.2601C63.128 48.4938 66.0849 48.6366 67.8512 50.5848C67.9226 50.6562 67.9962 50.7645 68.0676 50.838L84.6203 70.3476L111.992 38.108C113.758 36.1599 116.715 36.017 118.663 37.7833C120.503 39.4414 120.754 42.2554 119.204 44.2035V44.2014Z",
    fill: "#4195F5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6562_23080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.894 96.8916H20.7494C16.5653 96.8916 13.1733 100.284 13.1733 104.468V158.799C13.1733 162.983 16.5653 166.375 20.7494 166.375H158.894C163.078 166.375 166.47 162.983 166.47 158.799V104.468C166.47 100.284 163.078 96.8916 158.894 96.8916Z",
    fill: "#C9C9C9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6562_23080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2037 65.1396C13.9461 66.5207 13.1733 68.3476 13.1733 70.3628V158.73C13.1733 160.744 13.9461 162.573 15.2037 163.954L82.7955 106.031L15.2037 65.1396Z",
    fill: "#DBDBDB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6562_23080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.44 65.1396C165.698 66.5207 166.47 68.3476 166.47 70.3628V158.73C166.47 160.744 165.698 162.573 164.44 163.954L96.8483 106.031L164.44 65.1418V65.1396Z",
    fill: "#DBDBDB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6562_23080",
    x: 11.6581,
    y: 93.8612,
    width: 156.76,
    height: 72.9468,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.21646,
    dy: -1.29876
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.86584
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.388235 0 0 0 0 0.388235 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6562_23080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6562_23080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6562_23080",
    x: 9.92644,
    y: 61.6763,
    width: 76.5489,
    height: 105.741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.21646
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.73168
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.388235 0 0 0 0 0.388235 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6562_23080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6562_23080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6562_23080",
    x: 93.6014,
    y: 61.6763,
    width: 76.5489,
    height: 105.741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.21646
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.73168
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.388235 0 0 0 0 0.388235 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6562_23080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6562_23080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6562_23080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164.077,
    height: 193,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationEmail);
export default __webpack_public_path__ + "static/media/confirmation_email.6aeaa74ec7b0cd2b5a4065ff9c8c3a9d.svg";
export { ForwardRef as ReactComponent };